import { useProductNameAndUrl } from 'pages/trading/queryHooks';
import { AttributeCode, useModelService } from 'services/model/model.service';

export const useTranslatedAttribute = (attributeCode: string, attributeValue: string) => {
  const { data: productName } = useProductNameAndUrl(attributeValue);

  const modelService = useModelService();

  if (!attributeCode) return attributeValue ?? '';
  if (attributeCode === 'prdNumber') return productName?.name ?? attributeValue;

  return modelService.getAttribute(attributeCode as AttributeCode).translate(attributeValue);
};
